import { type HistoryRouter } from '@repair/catalog/types/config/algolia';

const generateSlug = (items: string[], prefix: string) => `${prefix}_${items.map(item => encodeURIComponent(item.toLowerCase())).join('_')}`;

const extractSegment = (pathname: string, pattern: string, transform?: (item: string) => string) => {
  const match = pathname.match(new RegExp(`${pattern}_([a-z0-9%_-]+)`, 'i'));

  return match
    ? match[1].split('_').map(item => {
        const decoded = decodeURIComponent(item);
        return transform ? transform(decoded) : decoded;
      })
    : [];
};

export const historyRouter: HistoryRouter = {
  createURL({ location, routeState }) {
    const baseUrl = location.href.split('/f-')[0];
    const groupNatureLevelThreePath = routeState.natures ? `/${generateSlug(routeState.natures, 'f-nature')}` : '';
    const brandsPath = routeState.brands ? `/${generateSlug(routeState.brands, 'f-brand')}` : '';
    const colorsPath = routeState.colors ? `/${generateSlug(routeState.colors, 'f-color')}` : '';
    const providersPath = routeState.providers ? `/${generateSlug(routeState.providers, 'f-provider')}` : '';

    return `${baseUrl}${groupNatureLevelThreePath}${brandsPath}${colorsPath}${providersPath}`;
  },
  parseURL({ location }) {
    const natures = extractSegment(location.pathname, 'f-nature');
    const brands = extractSegment(location.pathname, 'f-brand', item => item.toUpperCase());
    const colors = extractSegment(location.pathname, 'f-color');
    const providers = extractSegment(location.pathname, 'f-provider', item => item.toUpperCase());

    return {
      natures,
      brands,
      colors,
      providers,
    };
  },
};
